<template>
    <div class="ranking_wrapper" data-chart="ranking">
        <div class="app_timeline ranking_timeline" :data-isplaying="isPlaying" v-if="hasTimeline">
            <button class="timeline_bt" @click="togglePlay"></button>
            <div class="timeline_year">{{currentYear}}</div>
            <v-slider class="timeline_slider" v-model="currentYear" :min="minYear" :max="maxYear" @start="dragStart" @end="dragEnd"></v-slider>
        </div>
        <div class="ranking_area" :class="(expandedRanking) ? 'expanded' : ''">
            <div class="loader lds-ellipsis" :class="(loaderDisplayed) ? 'displayed' : ''"><div></div><div></div><div></div><div></div></div>
            <div class="ranking_slot" v-for="(countryObj, rankingIndex) in rankingSlots"></div>

            <div class="country_bar_container" v-for="(countryObj, rankingIndex) in rankingSlots" :data-country="countryObj.countryCode">
                <div class="container_inner">
                    <div class="country_label">
                        {{countryObj.countryLabel}}
                        <div class="label_rank" v-if="countryObj.years[String(currentYear)] != undefined && countryObj.years[String(currentYear)].value != 'nodata' && countryObj.years[String(currentYear)].value != null"></div>
                    </div>
                    <div class="country_bar">
                        <div class="bar_value" v-if="countryObj.years[String(currentYear)] != undefined">
                            <span v-if="countryObj.years[String(currentYear)].value == 'nodata' || countryObj.years[String(currentYear)].value == null" class="value_nodata">No data</span>
                            <span v-else>{{ countryObj.years[String(currentYear)].displayedValue }}{{indicatorUnit}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ranking_expandbar">
            <div class="expandbar_bt" @click="expandedRanking = !expandedRanking">
                <span v-if="!expandedRanking">Expand all ranking</span>
                <span v-else>Collapse all ranking</span>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import * as UTILS from '~/commons/utils/index.js'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import axios from 'axios'
    import {_} from 'underscore'
    var numberFormat = require('underscore.string/numberFormat')

    import Vuetify from 'vuetify'
    Vue.use(Vuetify)
    import 'vuetify/dist/vuetify.min.css'

    export default {
        components: {
            
        },

        props: {
            chartID: {
                type: String,
                default: function () {
                    return 'BarChart'
                }
            },
            rankingData: {
                type: Array,
                default: function (){
                    return [];
                }
            },
            indicatorUnit: {
                type: String,
                default: function (){
                    return ""
                }
            },
            hasTimeline: {
                type: Boolean,
                default: function (){
                    return true;
                }
            },
            sortingOrder: {
                type: String,
                default: function () {
                    return "desc"
                }
            }
        },
        data: function () {
            return {
                isDOMCreated: false,
                incrementTop: 56,
                maxDisplayBarPct: 80,
                minDisplayBarPct: 3,
                maxYearValue: 0,

                rankingSlots: [],
                availableYears: [],
                currentYear: 2000,
                minYear: 2000,
                maxYear: 2030,
                isPlaying: false,
                timerId: null,
                expandedRanking: false,
                loaderDisplayed: false
            }
        },
        
        mounted () {
            var self = this;
            this.renderRankingGraph();
        },
        methods: {
            renderRankingGraph: function (){
                var self = this;
                this.loaderDisplayed = true;

                if(this.rankingData.length > 0){
                    this.availableYears = _.keys(this.rankingData[0].years);
                    this.currentYear = parseInt(this.availableYears[this.availableYears.length - 1], 10);
                    this.maxYear = this.currentYear;
                    this.minYear = parseInt(this.availableYears[0], 10);
                    this.maxYearValue = UTILS.computeYearsMaxValue(this.rankingData);
                    this.rankingSlots = _.filter(this.rankingData, function (o){
                        if(o.years[String(self.currentYear)] != undefined && o.years[String(self.currentYear)].value != 'nodata' && o.years[String(self.currentYear)].value != null){
                            o.years[String(self.currentYear)].displayedValue = UTILS.formatNumber(o.years[String(self.currentYear)].value, 2);
                            return true;
                        } return false;
                    })

                    setTimeout(function (){
                        self.loaderDisplayed = false;
                        self.updateYearlyRanking();
                        self.isDOMCreated = true;
                    }, 100);
                }
            },

            updateYearlyRanking: function (){
                var self = this;

                var sortedRankingData = _.sortBy(this.rankingSlots, function (rankingObj){

                    if(rankingObj.years[String(self.currentYear)] == undefined || rankingObj.years[String(self.currentYear)].value == 'nodata'){
                        return 10000;
                    } else {
                        rankingObj.years[String(self.currentYear)].displayedValue = UTILS.formatNumber(rankingObj.years[String(self.currentYear)].value, 2);
                        if(self.sortingOrder == "asc") return rankingObj.years[String(self.currentYear)].value;
                        return -rankingObj.years[String(self.currentYear)].value;
                    }
                });

                var currentTop = 0;
                _.each(sortedRankingData, function (rankingObj, index){
                    var $container = document.querySelector(".country_bar_container[data-country='"+rankingObj.countryCode+"']");
                    var $bar = document.querySelector(".country_bar_container[data-country='"+rankingObj.countryCode+"'] .country_bar");
                    var $labelRank = document.querySelector(".country_bar_container[data-country='"+rankingObj.countryCode+"'] .label_rank");
                    if($container != null){
                        $container.style.top = currentTop + "px";
                        currentTop += self.incrementTop;

                        var countryValue = "nodata";
                        if(rankingObj.years[String(self.currentYear)] != undefined){
                            countryValue = rankingObj.years[String(self.currentYear)].value
                        }
                        var barWidth = (countryValue * self.maxDisplayBarPct) / self.maxYearValue;
                        if(barWidth < self.minDisplayBarPct) barWidth = self.minDisplayBarPct;

                        if(countryValue == "nodata" || countryValue == null){
                            $bar.style.width = 0;
                        } else if(countryValue == 0){
                            $bar.style.width = "1%";
                            if($labelRank != null) $labelRank.innerHTML = (index + 1);
                        } else{
                            $bar.style.width = barWidth + "%";
                            if($labelRank != null) $labelRank.innerHTML = (index + 1);
                        }
                    }
                })
            },

            togglePlay() {
                this.isPlaying = !this.isPlaying;

                if (this.isPlaying) {
                    this.startTimer();
                } else {
                    this.stopTimer();
                }
            },
            startTimer() {
                if(this.currentYear >= this.maxYear){
                    this.currentYear = this.minYear;
                }

                this.timerId = setInterval(() => {
                    if (this.currentYear < this.maxYear) {
                      this.currentYear++;
                    } else {
                      this.stopTimer();
                    }
                }, 2000);
            },

            stopTimer() {
                clearInterval(this.timerId);
                this.timerId = null;
                this.isPlaying = false;
            },

            dragStart(){
                this.stopTimer();
            },

            dragEnd() {
                this.stopTimer();
            }
        },
        watch: {
            rankingData: function () {
                if(this.rankingData[0] !== undefined) {
                    this.renderRankingGraph();
                }
            },

            currentYear: function () {
                var self = this;
                if(this.isDOMCreated) this.updateYearlyRanking(this.currentYear);
            }
        }
    }
</script>

<style lang="scss">
    @import "~assets/scss/_variables.scss";
    @import "~assets/scss/_browsers.scss";

    .ranking_wrapper{
        width: 580px;
        height: 100%;
        position: relative;
        text-align: center;

        .ranking_expandbar{
            width: 928px;
            height: 1px;
            background: #BAC6DF;
            position: relative;
            margin-top: 40px;
            .expandbar_bt{
                background: $colorBlue;
                color: #fff;
                height: 24px;
                line-height: 24px;
                padding: 0 24px 0 12px;
                border-radius: 12px;
                font-size: 14px;
                border: 0px solid;
                cursor: pointer;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                display: inline-block;
                &:after{
                    content: "";
                    position: absolute;
                    right: 2px;
                    top: 50%;
                    transform: translate(0, -50%);
                    background: url("/images/ellipsis.svg") no-repeat 0 0;
                    background-size: 100% 100%;
                    width: 21px;
                    height: 20px;
                }
                &:hover{
                    background: $colorBlueHover;
                }
            }
        }

        .ranking_area{
            width: 100%;
            position: relative;
            height: 560px;
            overflow: hidden;
            left: -32px;

            &.expanded{
                overflow: visible;
                height: auto;
            }
            
            .ranking_slot{
                height: 56px;
                width: 100%;
                display: inline-block;
                vertical-align: top;
                position: relative;
                margin-left: 32px;
                &:after{
                    content: "";
                    position: absolute;
                    left: 0px;
                    bottom: 0px;
                    height: 1px;
                    width: 100%;
                    background: #BAC6DF;
                }
            }
            .country_bar_container{
                position: absolute;
                left: 32px;
                top: 0px;
                height: 56px;
                width: 100%;
                transition: all 1s ease-in-out;
                .container_inner{
                    position: absolute;
                    left: 0px;
                    top: 50%;
                    transform: translate(0, -50%);
                    text-align: left;
                    width: 100%;
                    .country_label{
                        font-size: 16px;
                        font-weight: 700;
                        color: $colorBlack;
                        display: block;
                        position: relative;
                        .label_rank{
                            position: absolute;
                            right: 100%;
                            top: 50%;
                            transform: translate(0, -50%);
                            background: #EEF1F6;
                            width: 32px;
                            border-radius: 12px;
                            text-align: center;
                            height: 24px;
                            line-height: 26px;
                            font-size: 12px;
                            font-weight: 700;
                            color: #29264C;
                        }
                    }
                    .country_bar{
                        position: relative;
                        height: 16px;
                        width: 80%;
                        background: $colorBlue;
                        margin-top: 4px;
                        transition: all 0.3s ease-in-out;
                        .bar_value{
                            white-space: nowrap;
                            position: absolute;
                            left: 100%;
                            top: 50%;
                            margin-left: 8px;
                            transform: translate(0, -50%);
                            font-size: 16px;
                            color: $colorBlack;
                            .value_nodata{
                                margin-left: 0px;
                                display: inline-block;
                                color:#BAC6DF;
                                padding-left: 6px;
                                position: relative;
                                left: -8px;
                                &:before{
                                    content: "";
                                    position: absolute;
                                    left: 0px;
                                    top: 50%;
                                    height: 100%;
                                    transform: translate(0, -50%);
                                    width: 2px;
                                    background: #BAC6DF;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// components/rankingGraph.vue